import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotifierService } from './notifier.service';

export interface ErrorMessage {
  status: string;
  statusCode: number;
  timestamp: string;
  message: string;
  subCode: string;
  subCodeDescription: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    this.logError(error);
  }

  constructor(private notify: NotifierService) {}

  private generateError(error): ErrorMessage {
    if (error.error) {
      return {
        status: error.statusText,
        statusCode: error.status,
        timestamp: error.error.timestamp,
        message: error.error.Message,
        subCode: error.error.subCode,
        subCodeDescription: error.error.subCodeDescription
      };
    } else {
      return {
        status: 'INTERNAL_SERVER_ERROR',
        statusCode: 500,
        timestamp: new Date().toISOString(),
        message: 'Something went wrong',
        subCode: '500',
        subCodeDescription: 'Something went wrong'
      };
    }
  }

  public logError(error: any) {
    const date = new Date().toISOString();
    if (error instanceof HttpErrorResponse) {
      this.notify.showServerError(this.generateError(error));
    } else {
      console.error(date, '**** APPLICATION ERROR ***', error);
    }
  }
}
